import { Asset3DController } from "./Asset3DController";
import { AssetController } from "./AssetController";
import { BestPracticeController } from "./BestPracticeController";
import { BookmarkController } from "./BookmarkController";
import { CalendarEntryController } from "./CalendarEntryController";
import { ChatController } from "./ChatController";
import { ContentController } from "./ContentController";
import { CSSController } from "./CSSController";
import { CustomerInformationController } from "./CustomerInformationController";
import { DashboardController } from "./DashboardController";
import { DefaultController } from "./DefaultController";
import { EventController } from "./EventController";
import { FunctionController } from "./FunctionController";
import { GameController } from "./GameController";
import { GroupController } from "./GroupController";
import { I18NController } from "./I18NController";
import { InAppMessageController } from "./InAppMessageController";
import { LoginController } from "./LoginController";
import { MediaController } from "./MediaController";
import { MediaServiceController } from "./MediaServiceController";
import { MobileAppController } from "./MobileAppController";
import { NoticeController } from "./NoticeController";
import { NotificationController } from "./NotificationController";
import { OrganisationController } from "./OrganisationController";
import { PALMSController } from "./PALMSController";
import { PlaylistController } from "./PlaylistController";
import { PositionController } from "./PositionController";
import { PostController } from "./PostController";
import { PostControllerAsset3D } from "./PostControllerAsset3D";
import { PostControllerCommunity } from "./PostControllerCommunity";
import { PostControllerExcite } from "./PostControllerExcite";
import { PostControllerLandingPage } from "./PostControllerLandingPage";
import { PostControllerQuiz } from "./PostControllerQuiz";
import { PostControllerTube } from "./PostControllerTube";
import { PPNController } from "./PPNController";
import { QuestionController } from "./QuestionController";
import { QuizController } from "./QuizController";
import { ScormController } from "./ScormController";
import { ScormPostController } from "./ScormPostController";
import { SlideshowController } from "./SlideshowController";
import { StatisticsController } from "./StatisticsController";
import { TranslationController } from "./TranslationController";
import { UIStepController } from "./UIStepController";
import { URLController } from "./URLController";
import { UserController } from "./UserController";
import { ValuesController } from "./ValuesController";
import { WikiController } from "./WikiController";
export default function controllerFactory(controllerName) {
    var ctr = undefined;
    switch (controllerName) {
        case "Asset3DController":
            ctr = Asset3DController;
            break;
        case "AssetController":
            ctr = AssetController;
            break;
        case "BestPracticeController":
            ctr = BestPracticeController;
            break;
        case "BookmarkController":
            ctr = BookmarkController;
            break;
        case "CalendarEntryController":
            ctr = CalendarEntryController;
            break;
        case "ChatController":
            ctr = ChatController;
            break;
        case "ContentController":
            ctr = ContentController;
            break;
        case "CSSController":
            ctr = CSSController;
            break;
        case "CustomerInformationController":
            ctr = CustomerInformationController;
            break;
        case "DashboardController":
            ctr = DashboardController;
            break;
        case "DefaultController":
            ctr = DefaultController;
            break;
        case "EventController":
            ctr = EventController;
            break;
        case "FunctionController":
            ctr = FunctionController;
            break;
        case "GameController":
            ctr = GameController;
            break;
        case "GroupController":
            ctr = GroupController;
            break;
        case "I18NController":
            ctr = I18NController;
            break;
        case "InAppMessageController":
            ctr = InAppMessageController;
            break;
        case "LoginController":
            ctr = LoginController;
            break;
        case "MediaController":
            ctr = MediaController;
            break;
        case "MediaServiceController":
            ctr = MediaServiceController;
            break;
        case "MobileAppController":
            ctr = MobileAppController;
            break;
        case "NoticeController":
            ctr = NoticeController;
            break;
        case "NotificationController":
            ctr = NotificationController;
            break;
        case "OrganisationController":
            ctr = OrganisationController;
            break;
        case "PALMSController":
            ctr = PALMSController;
            break;
        case "PlaylistController":
            ctr = PlaylistController;
            break;
        case "PositionController":
            ctr = PositionController;
            break;
        case "PostController":
            ctr = PostController;
            break;
        case "PostControllerAsset3D":
            ctr = PostControllerAsset3D;
            break;
        case "PostControllerCommunity":
            ctr = PostControllerCommunity;
            break;
        case "PostControllerExcite":
            ctr = PostControllerExcite;
            break;
        case "PostControllerLandingPage":
            ctr = PostControllerLandingPage;
            break;
        case "PostControllerQuiz":
            ctr = PostControllerQuiz;
            break;
        case "PostControllerTube":
            ctr = PostControllerTube;
            break;
        case "PPNController":
            ctr = PPNController;
            break;
        case "QuestionController":
            ctr = QuestionController;
            break;
        case "QuizController":
            ctr = QuizController;
            break;
        case "ScormController":
            ctr = ScormController;
            break;
        case "ScormPostController":
            ctr = ScormPostController;
            break;
        case "SlideshowController":
            ctr = SlideshowController;
            break;
        case "StatisticsController":
            ctr = StatisticsController;
            break;
        case "TranslationController":
            ctr = TranslationController;
            break;
        case "UIStepController":
            ctr = UIStepController;
            break;
        case "URLController":
            ctr = URLController;
            break;
        case "UserController":
            ctr = UserController;
            break;
        case "ValuesController":
            ctr = ValuesController;
            break;
        case "WikiController":
            ctr = WikiController;
            break;
    }
    return ctr;
}
//# sourceMappingURL=ControllersFactory.js.map